/*
 * @Author: liujunhong
 * @Date: 2023/2/13
 * @Desc: 发送短信
 */

import React, { ChangeEvent, FC } from 'react';
import { SendVerificationCode } from 'gyyx-component-lib';
import styles from './style.less';

interface Props {
  sourceType: string,
  account?: string,
  inputId: string,
  btnId: string
  value: string,
  bid?: string,
  onChange: (val: string) => void,
  reset?: never
}


const Index: FC<Props> = props => {
  const {value, inputId, btnId, sourceType, onChange, ...reset} = props;

  return <div className={styles.send_sms_wrap}>
    <SendVerificationCode {...reset} sourceType={sourceType} vcValue={value} sendInputId={inputId} sendBtnId={btnId}
                          onChangeInput={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}/>
  </div>;
};
export default Index;
